export default __webpack_public_path__ + "static/sheet-9984633e606c2112ababbae575d18fec.png";